import React, {Component} from 'react';
import { Route } from "react-router-dom";
import './App.css';
import Home from './Home';
import styled from 'styled-components';

class App extends Component {

  constructor(props) {
      super(props) //since we are extending class Table so we have to use super in order to override Component class constructor
      this.state = { //state is by default an object
         products: [
            {  options: 'Mobile License', quantity: 0, months: 0, cost: 0, license_price: 25, discount: 0 },
            {  options: 'Smart Glasses License', quantity: 0, months: 0, cost: 0, license_price: 40, discount: 0  },
            {  options: 'Smart Glasses', quantity: 0, months: 12, cost: 0, license_price: 600, discount: 0 } // leave months 12 to make the algorith work
         ],
         subtotal: 0,
         tax: 0,
         total:0,
         discounts: 0
      }
   }

   updateMonthsValue = (index, evt) => {
     if(evt.target.validity.valid){
       const {products} = this.state;
       products[index].months = evt.target.value;
       this.setState({products});
       this.calculateCost(index);
     }
   }


   updateQuantityValue = (index, evt) => {
     if(evt.target.validity.valid){
       const {products} = this.state;
       products[index].quantity = evt.target.value;
       this.setState({products});
       this.calculateCost(index);
     }
   }

   calculateCost = (index) => {
     const {products} = this.state;
     const{ quantity, months, license_price } = products[index];


    if(quantity >= 0 && months >= 0){
      let newCost = license_price * parseInt(quantity,10) * parseInt(months,10);

      if(index === 2){ // used for ar glasses
        newCost = license_price * parseInt(quantity,10);
      }

      let total = parseFloat(Math.round(newCost * 100) / 100).toFixed(2);

      if(isNaN(total)){ total = 0; }

      products[index].cost = total;


      let quantityDiscount = 0;
      let monthDiscount = 0;

       if(quantity >= 10 && quantity <= 100){
         quantityDiscount = total * .10;
       }

       if(quantity > 100){
          quantityDiscount = total * .15;
       }

       if( months >= 12){
         monthDiscount = total * .10;
       }

       const discount = monthDiscount + quantityDiscount;

       products[index].discount = discount;

       let tax = 0;
       let totalAll = 0;
       let subtotal = 0;
       let finalDiscount = 0;

       products.map((pr) => {
         if(pr.cost > 0){
            const costNum = parseInt(pr.cost, 10);
            subtotal += costNum;
         }

         if(pr.discount > 0){
           const disNum = parseInt(pr.discount, 10);
            finalDiscount += disNum ;
         }
       });

       tax = .0825 * (subtotal - finalDiscount);
       totalAll = subtotal - finalDiscount + tax;

       if(isNaN(tax)){ tax = 0; }
       if(isNaN(totalAll)){ totalAll = 0; }
       if(isNaN(subtotal)){ subtotal = 0; }
       if(isNaN(finalDiscount)){ finalDiscount = 0; }
       this.setState({
         total: totalAll,
         discounts: finalDiscount,
         tax: tax,
         subtotal: subtotal,
         products,
        });


    } else {

      this.setState({products});
    }






   }

   renderTableData() {
      return this.state.products.map((student, index) => {
         const { id, options, quantity, months, cost } = student //destructuring
         return (
            <tr key={id}>
               <Td>{options}</Td>
               <Td>
                  <Inp type="text" pattern="[0-9]*" value={quantity} onChange={e => this.updateQuantityValue(index, e)}/>
               </Td>
               <Td> {options === 'Smart Glasses' ? null : <Inp type="text" pattern="[0-9]*" value={months} onChange={e => this.updateMonthsValue(index, e)}/>  }  </Td>
               <Td>{`$${ parseFloat(Math.round(cost * 100) / 100).toFixed(2)}`}</Td>
            </tr>
         )
      })
   }

   renderTableHeader() {
      let header = Object.keys(this.state.products[0])
      return header.map((key, index) => {
         return <th key={index}>{key.toUpperCase()}</th>
      })
   }

render(){
const {tax, total, discounts, subtotal} = this.state;
  return (
    <div className="App">
        <Container>
            <TableContainer>
              <Table >
                 <tbody>
                    <tr>
                      <Tha>Enterprise Pricing</Tha>
                    </tr>
                    <tr >
                      <Tda> * 10% discount applied to the cost when 12 months or more added</Tda>
                    </tr>
                    <tr >
                       <Tda> * 10% discount applied to the cost when 10-100 licenses added</Tda>
                    </tr>
                    <tr>
                       <Tda> * 15% discount applied when to the cost when 101 or more licenses added</Tda>
                    </tr>
                 </tbody>
              </Table>
              <Table marginTop={true}>
                 <tbody>
                    <tr>
                      <Th>Options</Th>
                      <Th>Quantity</Th>
                      <Th>Months</Th>
                      <Th>Cost</Th>
                    </tr>
                    {this.renderTableData()}
                    <Thc>Order</Thc>
                    <Thc></Thc>
                    <Thc>Subtotal:</Thc>
                    <Thc> {`$${parseFloat(Math.round(subtotal * 100) / 100).toFixed(2)}`}</Thc>
                    <tr>
                      <th></th>
                      <th></th>
                      <Tha>Tax:</Tha>
                      <Th>{`$${parseFloat(Math.round(tax * 100) / 100).toFixed(2)}`}</Th>
                    </tr>
                    <tr>
                      <th></th>
                      <th></th>
                      <Tha>Discount:</Tha>
                      <Th>{`$${parseFloat(Math.round(discounts * 100) / 100).toFixed(2)}`}</Th>
                    </tr>
                    <tr>
                      <th></th>
                      <th></th>
                      <Tha>Total:</Tha>
                      <Th>{`$${parseFloat(Math.round(total * 100) / 100).toFixed(2)}`}</Th>
                    </tr>
                 </tbody>
              </Table>

            </TableContainer>
         </Container>
      <main>
         <Route exact path="/calculator/" component={Home} />
       </main>
    </div>
  );


  }

}

export default App;

const Container = styled.div`
  display: flex;
  justify-content: center;
  flex-direction:column;
  align-items:center;
`;

const TableContainer = styled.div`
  display: flex;
  justify-content: center;
  flex-direction:row;
  width: 100%;
  flex-wrap: wrap;
`;


const Table = styled.table`
  box-shadow: 0 0px 13px rgba(18,63,129,0.30), 0 8px 6px rgba(18,63,129,0.22);
   background-image: linear-gradient(to right, #123F81 , #3FB8C7);
  text-align: center;
  font-family: "Trebuchet MS", Arial, Helvetica, sans-serif;
  border-collapse: collapse;
  border: 1px solid #ddd;
  width: 100%;
  height: 200px;
  margin-left: ${props => props.marginLeft ? "30px": "0px"}
  color: white;
  margin-top: ${props => props.marginTop ? "30px": "0px"}
`;

const Td = styled.td`
  border: 1px solid #ddd;
  padding: 8px;
`;

const Th = styled.th`
  height: 32px;
  border: 1px solid #ddd;
  border-left: 0px solid transparent;
  padding: 8px;
`;

const Tha = styled.th`
  border: 1px solid #ddd;
  padding: 8px;
  height: 32px;
`;

const Tda = styled.td`
  text-align:left;
  padding-left: 21px;
`;

const Inp = styled.input`
  outline: none;
  text-align: center;
  border-radius: 19px;
  border: 1px solid #ddd;
  height: 20px;
  background-color:white;
  color:white;
`;

const Thc = styled.th`
  background-color: #32CD32;
  border: 1px solid #ddd;
  padding: 8px;
  height: 32px;
  color: white;
`;
